import { commonRequest } from "@devowl-wp/utils";
import { locationRestCopyPost } from "../wp-api/copy.post.js";
/**
 * Create a copy of a multilingual object like post or term.
 */ async function createCopy(objectType, id, targetLocale) {
    const { root, nonce } = window.wpApiSettings;
    const { translations } = await commonRequest({
        location: locationRestCopyPost,
        options: {
            restRoot: root,
            restNonce: nonce,
            restNamespace: "wp/v2",
            restQuery: {}
        },
        request: {
            id,
            targetLocale
        },
        params: {
            objectType
        }
    });
    return translations[targetLocale];
}
export { createCopy };
